import React from "react";
import { ArrowForward, CheckCircleOutline } from "@mui/icons-material";
import { Box, Button } from "@mui/material";

const AddToTargetBtn = ({ onClick }) => (
  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2.5 }}>
    <Button
      variant="contained"
      onClick={onClick}
      startIcon={<CheckCircleOutline />}
      endIcon={<ArrowForward />}
      sx={{
        minHeight: 44,
        px: 2.5,
        borderRadius: 2,
        fontSize: "0.925rem",
        fontWeight: 700,
        boxShadow: "0 6px 16px rgba(18, 140, 126, 0.18)",
        transition: "transform 180ms ease, box-shadow 180ms ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 8px 20px rgba(18, 140, 126, 0.24)",
        },
      }}
    >
      Confirm audience and review
    </Button>
  </Box>
);

export default AddToTargetBtn;
